export const ids = ['stocking', 'special_order', 'obsolete'] as const;
